import Cookies from 'js-cookie'
var CryptoJS = require('crypto-js')


   export const encrypt=data=>CryptoJS.AES.encrypt(data, 'gaat').toString();
 
  export const decrypt=data=>{
  var byte =  CryptoJS.AES.decrypt(data, 'gaat')
  return byte.toString(CryptoJS.enc.Utf8)
  } 

  
export const userToken =Cookies.get('gaatpkarfsh')?decrypt(Cookies.get('gaatpkarfsh')):[]